import "./sidebar.scss";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import StoreIcon from "@mui/icons-material/Store";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import SettingsSystemDaydreamOutlinedIcon from "@mui/icons-material/SettingsSystemDaydreamOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import PublicIcon from '@mui/icons-material/Public';
import BusinessIcon from '@mui/icons-material/Business';
import {Link, useNavigate} from "react-router-dom";
import { DarkModeContext } from "../../context/darkModeContext";
import { AuthContext } from "../../context/AuthContext";
import { useContext } from "react";
import {ConfirmationNumber, FolderSpecial} from "@mui/icons-material";
import Footer from "../Footer/Footer";
import newRequest from "../../context/newRequest";

const Sidebar = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  const handleLogout = async (token) => {
    try {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      authContext.dispatch({ type: "LOGOUT" });
      await newRequest.delete("/users");
      navigate("/login");
    } catch (err) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      authContext.dispatch({ type: "LOGOUT" });
      navigate("/login");
      console.log(err);
    }
  };
  const { dispatch } = useContext(DarkModeContext);
  return (
      <div className="sidebar">
        <div className="top">
          <Link to="/" style={{textDecoration: "none"}}>
            <span className="logo">GREENET</span>
          </Link>
        </div>
        <hr/>
        <div className="center">
          <ul>
            <p className="title">MAIN</p>
            <li>
              <DashboardIcon className="icon"/>
              <span>Dashboard</span>
            </li>
            <p className="title">LISTS</p>
            <Link to="/users" style={{textDecoration: "none"}}>
              <li>
                <PersonOutlineIcon className="icon"/>
                <span>Users</span>
              </li>
            </Link>
            <Link to="/regions" style={{textDecoration: "none"}}>
              <li>
                <PublicIcon className="icon"/>
                <span>Regions</span>
              </li>
            </Link>
            <Link to="/vendors" style={{textDecoration: "none"}}>
              <li>
                <BusinessIcon className="icon"/>
                <span>Vendors</span>
              </li>
            </Link>
            <p className="title">Ticket B2B</p>
            <Link to="/ticket" style={{textDecoration: "none"}}>
              <li>
                <StoreIcon className="icon"/>
                <span>Ticket Opens</span>
              </li>
            </Link>
            <Link to="/solve" style={{textDecoration: "none"}}>
              <li>
                <CreditCardIcon className="icon"/>
                <span>Ticket Solved</span>
              </li>
            </Link>
            <Link to="/closed" style={{textDecoration: "none"}}>
              <li>
                <RuleFolderIcon className="icon"/>
                <span>Ticket Closed</span>
              </li>
            </Link>
            <Link to="/detail" style={{textDecoration: "none"}}>
              <li>
                <ConfirmationNumber className="icon"/>
                <span>Ticket Detail</span>
              </li>
            </Link>
            <p className="title">USEFUL</p>
            <Link to="/localsite" style={{textDecoration: "none"}}>
              <li>
                <FolderSpecial className="icon"/>
                <span>LocalSite</span>
              </li>
            </Link>
            <Link to="/ticketsite" style={{textDecoration: "none"}}>
              <li>
                <FolderSpecial className="icon"/>
                <span>Ticket B2C</span>
              </li>
            </Link>
            <Link to="/ticketsite/export" style={{textDecoration: "none"}}>
            <li>
              <InsertChartIcon className="icon"/>
              <span>Ticket B2C for Export</span>
            </li>
            </Link>
            <li>
              <NotificationsNoneIcon className="icon"/>
              <span>Notifications</span>
            </li>
            <p className="title">SERVICE</p>
            <li>
              <SettingsSystemDaydreamOutlinedIcon className="icon"/>
              <span>System Health</span>
            </li>
            <li>
              <PsychologyOutlinedIcon className="icon"/>
              <span>Logs</span>
            </li>
            <li>
              <SettingsApplicationsIcon className="icon"/>
              <span>Settings</span>
            </li>
            <p className="title">USER</p>
            <Link to="/users/_current" style={{textDecoration: "none"}}>
              <li>
                <AccountCircleOutlinedIcon className="icon"/>
                <span>Profile</span>
              </li>
            </Link>
            <li>
              <ExitToAppIcon onClick={handleLogout} className="icon"/>
              <span onClick={handleLogout}>Logout</span>
            </li>
          </ul>
        </div>
        <div className="bottom">
          <div
              className="colorOption"
              onClick={() => dispatch({type: "LIGHT"})}
          ></div>
          <div
              className="colorOption"
              onClick={() => dispatch({type: "DARK"})}
          ></div>
        </div>
        <div className="footer">
          <Footer/>
        </div>
      </div>
  );
};

export default Sidebar;
